import React, { useEffect, useReducer, useRef, useState } from 'react'
import Modal from '../../../../../Modal/Modal';
import { useDispatch, useSelector } from 'react-redux';
import classes from "../Sigfox/SigfoxModalForm.module.css"
import Input from '../../../../../CustomDropDown/Input/Input';
import Button1 from '../../../../Button/Button1';
import { addCamectAPI, addSensor, addSigfoxAPI, updateCamectAPI } from '../../../../../../Api Methods/Api';
import { checkAuthLoader } from '../../../../../../auth';
import Button2 from '../../../../Button/Button2';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';
import { Password } from 'primereact/password';
import { MAX_STATIC_ALARMS, MAX_DYNAMIC_ALARMS, SAMPLING_PERIOD_OPTIONS, POLLING_INTERVAL_OPTIONS, POLARITY_OPTIONS, CONNECTION_DAY_OPTIONS } from './tankSensorOptions';

const SensorIDReducer = (state, action) => {

    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: action.val.length > 0 };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.length > 0 };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: null };
    }
    //otherwise
    return { value: '', isValid: false };
}

const TankSensorForm = ({ setShowVirtualSource, inputs, fetchVirtualSources, setShowSuccess }) => {

    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);
    const apiData = {
        token,
        client
    }

    const [modalComponent, setModalComponent] = useState(null);
    const [modalPageIndex, setModalPageIndex] = useState(0);
    const [pinSelected, setPinSelected] = useState(null)

    const ModalDialog = useRef();
    const ClearStatesChildComponetRef = useRef();

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();

        HandelResetModal();
    }

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                HandelResetModal();
            }
        };
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const [formIsValid, setFormIsValid] = useState(false);

    const [sensorIDState, dispatchSensorIDState] = useReducer(SensorIDReducer, {
        value: '',
        isValid: null
    });

    const sensorIDInputRef = useRef();

    const [advancedOpen, setAdvancedOpen] = useState(false);

    // TEK880 tank sensors: sensor mounting height above the tank base/outlet, used to convert the
    // raw radar/ultrasonic distance reading into a fill level
    const [tankHeight, setTankHeight] = useState(null);
    // How often (minutes) the sensor logs a reading
    const [logInterval, setLogInterval] = useState(null);
    // 0 = 1 minute, 1 = 15 minutes, 2 = don't set a period - use the logging interval instead
    const [samplingPeriod, setSamplingPeriod] = useState(null);
    // Time of day (UTC) of the first connection to the server
    const [connectionTime, setConnectionTime] = useState(null);
    // Days of the week the sensor is allowed to connect, e.g. ["mon", "wed"]
    const [connectionDays, setConnectionDays] = useState([]);
    const [devicePassword, setDevicePassword] = useState('');
    // Reading quality filters (1-10) - a reading must score higher than this to trigger an alarm
    const [rccQualityScoreFilter, setRccQualityScoreFilter] = useState(null);
    const [rssiQualityScoreFilter, setRssiQualityScoreFilter] = useState(null);
    // How often (hours) the sensor polls/reports back to the server, or once per day
    const [pollingInterval, setPollingInterval] = useState(null);

    // Static alarms - triggers when the level passes a fixed threshold; hysteresis stops it re-triggering. Max 3.
    const [staticAlarms, setStaticAlarms] = useState([]);
    // Dynamic alarms - triggers on a rate-of-change between readings. Max 2.
    const [dynamicAlarms, setDynamicAlarms] = useState([]);

    const { isValid: sensorIDIsValid } = sensorIDState;

    useEffect(() => {
        const identifier = setTimeout(() => {
            setFormIsValid(sensorIDIsValid)
        }, 500);

        return () => {
            clearTimeout(identifier);
        };
    }, [sensorIDIsValid]);

    const sensorIDChangeHandler = (event) => {
        dispatchSensorIDState({ type: 'USER_INPUT', val: event.target.value });
    }

    const validateSensorIDHandler = () => {
        dispatchSensorIDState({ type: 'INPUT_BLUR' });
    }


    const HandelResetModal = () => {
        setModalPageIndex(null);
        setShowVirtualSource(null);
    }

    const onClearHandler = () => {
        dispatchSensorIDState({ type: 'INPUT_CLEAR', val: "" })
    }

    const addStaticAlarm = () => {
        setStaticAlarms(prev => prev.length >= MAX_STATIC_ALARMS ? prev : [...prev, { polarity: null, threshold: null, hysteresis: null }]);
    }

    const updateStaticAlarm = (index, field, value) => {
        setStaticAlarms(prev => prev.map((alarm, i) => i === index ? { ...alarm, [field]: value } : alarm));
    }

    const removeStaticAlarm = (index) => {
        setStaticAlarms(prev => prev.filter((_, i) => i !== index));
    }

    const addDynamicAlarm = () => {
        setDynamicAlarms(prev => prev.length >= MAX_DYNAMIC_ALARMS ? prev : [...prev, { polarity: null, rateOfChange: null }]);
    }

    const updateDynamicAlarm = (index, field, value) => {
        setDynamicAlarms(prev => prev.map((alarm, i) => i === index ? { ...alarm, [field]: value } : alarm));
    }

    const removeDynamicAlarm = (index) => {
        setDynamicAlarms(prev => prev.filter((_, i) => i !== index));
    }

    const dispatch = useDispatch();

    const submitHandler = async (event) => {
        event.preventDefault();

        const sensorDetails = {
            "siteUUID": DeviceUUID,
            "sensorID": sensorIDState.value,
            "name": "",
            "input": pinSelected.toString(),
            "sensorType": 10,
            "tankHeight": tankHeight ?? null,
            "logInterval": logInterval ?? null,
            "samplingPeriod": samplingPeriod ?? null,
            "connectionTime": connectionTime ? `${String(connectionTime.getUTCHours()).padStart(2, "0")}:${String(connectionTime.getUTCMinutes()).padStart(2, "0")}` : null,
            "connectionDays": connectionDays.length > 0 ? connectionDays.join(",") : null,
            "devicePassword": devicePassword ? devicePassword : null,
            "rccQualityScoreFilter": rccQualityScoreFilter ?? null,
            "rssiQualityScoreFilter": rssiQualityScoreFilter ?? null,
            "pollingInterval": pollingInterval ?? null,
            "staticAlarms": staticAlarms.length > 0 ? staticAlarms : null,
            "dynamicAlarms": dynamicAlarms.length > 0 ? dynamicAlarms : null,
        }
        console.log(sensorDetails);
        const responseData = await addSensor(apiData, sensorDetails, dispatch)
        console.log(responseData);
        if (responseData && responseData.success) {
            HandleCloseModal();
            fetchVirtualSources();
            setShowSuccess(true);
        }
    };


    const HandlePinSelected = (pin) => {
        setPinSelected(pin);
        setModalPageIndex(1);
    }

    useEffect(() => {
        switch (modalPageIndex) {
            case 0:
                setModalComponent(
                    <form onSubmit={submitHandler} className={classes["container"]} method="dialog">
                        <h3 style={{color:"#6e6e6e"}}>Which switch would you like to link the sensor to?</h3>
                        <br></br>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "15px" }}>

                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", gap: "20px", width: "100%" }}>
                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", gap: "20px", width: "100%" }}>
                                    <ul style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "center", gap: "10px" }}>
                                    {inputs.map((input) => {
                                            return (
                                                <li key={input.Pin}>
                                                    <Button2 style={{minWidth:"350px", minHeight:"50px"}}type={"button"} onClick={() => HandlePinSelected(input.Pin)}>
                                                        {input.pinName}
                                                    </Button2>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </form>
                )

                HandleShowModal();
                break;
            case 1:
                setModalComponent(
                    <form onSubmit={submitHandler} className={classes["container"]} method="dialog">
                        <ul className={classes["inputs-list"]}>
                            <li className={classes["input-container"]}>
                                <label className={classes.subTitle}>Enter Tank Sensor ID</label>
                                <Input
                                    className={classes.input}
                                    placeholder={"Sensor ID (IMEI)"}
                                    ref={sensorIDInputRef}
                                    id="CamectIP"
                                    type={"text"}
                                    isValid={sensorIDState.isValid}
                                    value={sensorIDState.value}
                                    onChange={sensorIDChangeHandler}
                                    onBlur={validateSensorIDHandler}
                                />

                            </li>

                            {/* {!advancedOpen ? (
                                <Button icon="pi pi-cog" label="Advanced options" severity="info" outlined rounded onClick={() => setAdvancedOpen(true)} />
                            ) : (
                                <>
                                    <li className={classes["input-container"]}>
                                        <label className={classes.subTitle}>Tank height</label>
                                        <InputNumber
                                            value={tankHeight}
                                            onValueChange={(e) => setTankHeight(e.value ?? null)}
                                            min={0}
                                            suffix=" cm"
                                            placeholder="e.g. 250"
                                            style={{ width: "100%" }}
                                            inputStyle={{ width: "100%" }}
                                        />
                                        <small style={{ color: "#6e6e6e" }}>Height from the base of the TEK880 sensor to the base of the tank/outlet, used to convert the radar reading into a fill level.</small>
                                    </li>

                                    <li className={classes["input-container"]}>
                                        <label className={classes.subTitle}>Log interval</label>
                                        <InputNumber
                                            value={logInterval}
                                            onValueChange={(e) => setLogInterval(e.value ?? null)}
                                            min={1}
                                            suffix=" min"
                                            placeholder="Optional"
                                            style={{ width: "100%" }}
                                            inputStyle={{ width: "100%" }}
                                        />
                                        <small style={{ color: "#6e6e6e" }}>How often the sensor logs a reading.</small>
                                    </li>

                                    <li className={classes["input-container"]}>
                                        <label className={classes.subTitle}>Sampling period</label>
                                        <Dropdown
                                            value={samplingPeriod}
                                            options={SAMPLING_PERIOD_OPTIONS}
                                            onChange={(e) => setSamplingPeriod(e.value)}
                                            placeholder="Optional"
                                            style={{ width: "100%" }}
                                        />
                                    </li>

                                    <li className={classes["input-container"]}>
                                        <label className={classes.subTitle}>First connection time (UTC)</label>
                                        <Calendar
                                            value={connectionTime}
                                            onChange={(e) => setConnectionTime(e.value ?? null)}
                                            timeOnly
                                            placeholder="Optional"
                                            style={{ width: "100%" }}
                                        />
                                    </li>

                                    <li className={classes["input-container"]}>
                                        <label className={classes.subTitle}>Connection days</label>
                                        <MultiSelect
                                            value={connectionDays}
                                            options={CONNECTION_DAY_OPTIONS}
                                            onChange={(e) => setConnectionDays(e.value)}
                                            placeholder="Optional"
                                            display="chip"
                                            style={{ width: "100%" }}
                                        />
                                    </li>

                                    <li className={classes["input-container"]}>
                                        <label className={classes.subTitle}>Device password</label>
                                        <Password
                                            value={devicePassword}
                                            onChange={(e) => setDevicePassword(e.target.value)}
                                            placeholder="Optional"
                                            feedback={false}
                                            toggleMask
                                            style={{ width: "100%" }}
                                            inputStyle={{ width: "100%" }}
                                        />
                                    </li>

                                    <li className={classes["input-container"]}>
                                        <label className={classes.subTitle}>RCC quality score filter</label>
                                        <InputNumber
                                            value={rccQualityScoreFilter}
                                            onValueChange={(e) => setRccQualityScoreFilter(e.value ?? null)}
                                            min={1}
                                            max={10}
                                            placeholder="1-10"
                                            style={{ width: "100%" }}
                                            inputStyle={{ width: "100%" }}
                                        />
                                        <small style={{ color: "#6e6e6e" }}>A reading must score higher than this to trigger an alarm.</small>
                                    </li>

                                    <li className={classes["input-container"]}>
                                        <label className={classes.subTitle}>RSSI quality score filter</label>
                                        <InputNumber
                                            value={rssiQualityScoreFilter}
                                            onValueChange={(e) => setRssiQualityScoreFilter(e.value ?? null)}
                                            min={1}
                                            max={10}
                                            placeholder="1-10"
                                            style={{ width: "100%" }}
                                            inputStyle={{ width: "100%" }}
                                        />
                                        <small style={{ color: "#6e6e6e" }}>A reading must score higher than this to trigger an alarm.</small>
                                    </li>

                                    <li className={classes["input-container"]}>
                                        <label className={classes.subTitle}>Polling interval</label>
                                        <Dropdown
                                            value={pollingInterval}
                                            options={POLLING_INTERVAL_OPTIONS}
                                            onChange={(e) => setPollingInterval(e.value)}
                                            placeholder="Optional"
                                            style={{ width: "100%" }}
                                        />
                                    </li>

                                    {staticAlarms.map((alarm, index) => (
                                        <li key={`static-${index}`} className={classes["input-container"]} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                            <label className={classes.subTitle}>Threshold alarm {index + 1}</label>
                                            <Dropdown
                                                value={alarm.polarity}
                                                options={POLARITY_OPTIONS}
                                                onChange={(e) => updateStaticAlarm(index, "polarity", e.value)}
                                                placeholder="Polarity"
                                                style={{ width: "100%" }}
                                            />
                                            <InputNumber
                                                value={alarm.threshold}
                                                onValueChange={(e) => updateStaticAlarm(index, "threshold", e.value ?? null)}
                                                min={0}
                                                suffix=" cm"
                                                placeholder="Threshold"
                                                style={{ width: "100%" }}
                                                inputStyle={{ width: "100%" }}
                                            />
                                            <InputNumber
                                                value={alarm.hysteresis}
                                                onValueChange={(e) => updateStaticAlarm(index, "hysteresis", e.value ?? null)}
                                                min={0}
                                                suffix=" cm"
                                                placeholder="Hysteresis"
                                                style={{ width: "100%" }}
                                                inputStyle={{ width: "100%" }}
                                            />
                                            <Button icon="pi pi-times" label="Remove" text severity="danger" size="small" type="button" onClick={() => removeStaticAlarm(index)} />
                                        </li>
                                    ))}
                                    {staticAlarms.length < MAX_STATIC_ALARMS && (
                                        <Button icon="pi pi-plus" label="Add threshold alarm" severity='info' type="button" onClick={addStaticAlarm}/>
                                    )}

                                    {dynamicAlarms.map((alarm, index) => (
                                        <li key={`dynamic-${index}`} className={classes["input-container"]} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                            <label className={classes.subTitle}>Rate of change alarm {index + 1}</label>
                                            <Dropdown
                                                value={alarm.polarity}
                                                options={POLARITY_OPTIONS}
                                                onChange={(e) => updateDynamicAlarm(index, "polarity", e.value)}
                                                placeholder="Polarity"
                                                style={{ width: "100%" }}
                                            />
                                            <InputNumber
                                                value={alarm.rateOfChange}
                                                onValueChange={(e) => updateDynamicAlarm(index, "rateOfChange", e.value ?? null)}
                                                min={0}
                                                suffix=" cm"
                                                placeholder="Rate of change"
                                                style={{ width: "100%" }}
                                                inputStyle={{ width: "100%" }}
                                            />
                                            <Button icon="pi pi-times" label="Remove" text severity="danger" size="small" type="button" onClick={() => removeDynamicAlarm(index)} />
                                        </li>
                                    ))}
                                    {dynamicAlarms.length < MAX_DYNAMIC_ALARMS && (
                                        <Button icon="pi pi-plus" label="Add rate of change alarm" severity='secondary' type="button" onClick={addDynamicAlarm}/>
                                    )}

                                    <Button icon="pi pi-times" label="Hide advanced options" text severity="secondary" size="small" type="button" onClick={() => setAdvancedOpen(false)} />
                                </>
                            )} */}
                        </ul>
                        <br/>
                        <Button  icon="pi pi-save" type="submit" label="Save" severity='success'/>

                    </form>
                )
                HandleShowModal();
                break;
        }
    }, [modalPageIndex, sensorIDState, advancedOpen, tankHeight, logInterval, samplingPeriod, connectionTime, connectionDays, devicePassword, rccQualityScoreFilter, rssiQualityScoreFilter, pollingInterval, staticAlarms, dynamicAlarms]);

    return (
        <>
            <Modal ref={ModalDialog} title={"Add Tank Sensor"} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} modalLayoutStyle={{ alignItems: "center" }}>
                {modalComponent}
            </Modal>
        </>
    )
}

export default TankSensorForm;
